module.exports = __webpack_public_path__ + "static/media/boomea-green.67ecce3f.svg";